/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.IPage<defs.basics.BankInfoResponseDto>>;
export function request(params: API.basics.bankInfo.page.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/bankInfo/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
